// A business customer is captured by putting the company name in this one
// field and leaving the last name empty; there is no separate business record.
const CUSTOMER_FIRST_NAME_LABEL = "First / Business Name"
const CUSTOMER_FIRST_NAME_PLACEHOLDER = "Enter First / Business Name"

export { CUSTOMER_FIRST_NAME_LABEL, CUSTOMER_FIRST_NAME_PLACEHOLDER }
